import React from 'react';
import { WarehouseListTemplate } from 'themes/modules/warehouse/pages';
import { setCurrentView } from 'core/utils';
import { WarehouseListViewStore } from 'modules/warehouse/stores';

@setCurrentView(rootStore => new WarehouseListViewStore(rootStore), 'warehouseListViewStore')
class WarehouseList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return (
			<WarehouseListTemplate
				{...this.props}
				change={this.props.warehouseListViewStore.change}
				actions={this.props.warehouseListViewStore}
				viewStore={this.props.warehouseListViewStore}
			/>
		);
	}
}

export default WarehouseList;



// WEBPACK FOOTER //
// ./src/modules/warehouse/pages/WarehouseList.jsx